import React from 'react';


// image dictionary
// AIRPORTS
import DUB from "_assets/images/profile/DUB-CIRCLE.png";
import ORK from "_assets/images/profile/ORK-CIRCLE.png";
import BFS from "_assets/images/profile/BFS-CIRCLE.png";
import BRS from "_assets/images/profile/BRS-CIRCLE.png";
import CFN from "_assets/images/account/CFN-CIRCLE.png";
import MRA from "_assets/images/account/MRA-CIRCLE.png";
import ALC from "_assets/images/account/ALC-CIRCLE.png";
import JED from "_assets/images/profile/jed.jpeg";
import Glasgow from "_assets/images/account/glasgow.jpeg";
import tui from "_assets/images/account/tui.png";
import ABZ from "_assets/images/airports/ABZ.jpeg";
import ACE from "_assets/images/airports/ACE.jpeg";
import ADB from "_assets/images/airports/ADB.jpeg";
import AGP from "_assets/images/airports/AGP.jpeg";
import AKL from "_assets/images/airports/AKL.jpeg";
import AMS from "_assets/images/airports/AMS.jpeg";
import BCN from "_assets/images/airports/BCN.jpeg";
import BER from "_assets/images/airports/BER.jpeg";
import PER from "_assets/images/airports/PER.png";

// AIRLINES
import RYANAIR from "_assets/images/profile/ryanair.png";
import AERLINGUS from "_assets/images/profile/AERLINGUS.jpeg";
import JET2 from "_assets/images/profile/jet2.png";
import EASYJET from "_assets/images/account/easy-jet.jpeg";

// TRAVEL AGENT
import surgeryNow from "_assets/images/account/surgery-now.jpeg";
import healthcareAbroad from "_assets/images/account/healthcare-abroad.png"

// profile picture component
const ImageDictionary = (props) => {
    if (props.travelAgent) {
        return (
            <>
                {
                    props.iata == 'Healthcare Abroad' ?
                        <img src={healthcareAbroad} style={props.style} />
                        :
                        <img src={surgeryNow} style={props.style} />
                }
            </>
        )
    }
    else {
        return (
            <>
                {
                    props.iata == 'DUB' ?
                        <img src={DUB} style={props.style} />
                        : props.iata == 'ORK' ?
                            <img src={ORK} style={props.style} />
                            : props.iata == 'BRS' ?
                                <img src={BRS} style={props.style} />
                                : props.iata == 'FR' ?
                                    <img src={RYANAIR} style={props.style} />
                                    : props.iata == 'U2' ?
                                        <img src={EASYJET} style={props.style} />
                                        : props.iata == 'EI' ?
                                            <img src={AERLINGUS} style={props.style} />
                                            : props.iata == 'BFS' ?
                                                <img src={BFS} style={props.style} />
                                                : props.iata == 'CFN' ?
                                                    <img src={CFN} style={props.style} />
                                                    : props.iata == 'RMU' ?
                                                        <img src={MRA} width={110} style={{ marginLeft: 12 }} />
                                                        : props.iata == 'ALC' ?
                                                            <img src={ALC} style={props.style} />
                                                            : props.iata == 'LS' ?
                                                                <img src={JET2} style={props.style} />
                                                                : props.iata == 'JED' ?
                                                                    <img src={JED} style={props.style} />
                                                                    : props.iata == 'GLA' ?
                                                                        <img src={Glasgow} style={props.style} />
                                                                        : props.iata == 'TOM' ?
                                                                            <img src={tui} style={props.style} />
                                                                            :
                                                                            props.iata == 'ABZ' ?
                                                                                <img src={ABZ} style={props.style} />
                                                                                : props.iata == 'ACE' ?
                                                                                    <img src={ACE} style={props.style} />
                                                                                    : props.iata == 'ADB' ?
                                                                                        <img src={ADB} style={props.style} />
                                                                                        : props.iata == 'AGP' ?
                                                                                            <img src={AGP} style={props.style} />
                                                                                            : props.iata == 'AKL' ?
                                                                                                <img src={AKL} style={props.style} />
                                                                                                : props.iata == 'AMS' ?
                                                                                                    <img src={AMS} style={props.style} />
                                                                                                    : props.iata == 'BCN' ?
                                                                                                        <img src={BCN} style={props.style} />
                                                                                                        : props.iata == 'BER' ? <img src={BER} style={props.style} />
                                                                                                            :
                                                                                                            props.iata == 'PER' ?
                                                                                                                <img src={PER} style={props.style} />
                                                                                                                : <></>
                }
            </>
        )
    }
}

export default ImageDictionary;